import { defineComponent, PropType } from 'vue';
import Showdown from 'showdown';

export default defineComponent({
  name: 'MarkdownMessageView',
  props: {
    text: {
      type: String as PropType<string>,
      required: true,
      default: '',
    },
  },
  computed: {
    markdown(): string {
      const customRule1 = {
        type: 'lang',
        regex: /<br\/?>/g,
        replace: '<br>',
      };
      const customRule2 = {
        type: 'lang',
        regex: /<hr\/?>/g,
        replace: '<div class="split"></div>',
      };
      const convert = new Showdown.Converter({
        extensions: [
          customRule1,
          customRule2,
        ],
        openLinksInNewWindow: true,
      });
      return convert.makeHtml(this.text);
    },
    /// 设计沟通不需要折叠了
    // containerCss(): string {
    //   return this.showButton ? 'max-height: 400px' : '';
    // },
  },
  mounted(): void {
    /// 设计沟通不需要折叠了
    // const elementHeight = (this.$refs.markdown as HTMLElement).offsetHeight;
    // if (elementHeight > 300) {
    //   this.showButton = true;
    // }
  },
});
